import { styled } from 'styled-components';
import { SVGProps } from 'react';

export interface SvgComponentProps extends Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> {
    size?: number;
    color?: string;
}

export const Svg = styled.svg
    .withConfig({
        // Remove "size" so it’s not forwarded to the DOM element
        shouldForwardProp: (prop) => prop !== 'size',
    })
    .attrs<SvgComponentProps>(({ size = 13 }) => ({
        width: size,
        height: size,
    }))<{ color?: string }>`
  color: ${(props) => props.color || 'currentColor'};
  pointer-events: none;
`;
